import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Australian date format: 30 Dec 2025
export function formatDateAU(dateString) {
  if (!dateString) return '—';
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleDateString('en-AU', { month: 'short' });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}

// 24-hour time format: 16:09
export function formatTimeAU(dateString) {
  if (!dateString) return '—';
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit', hour12: false });
}

// Full datetime: 30 Dec 2025, 16:09
export function formatDateTimeAU(dateString) {
  if (!dateString) return '—';
  return `${formatDateAU(dateString)}, ${formatTimeAU(dateString)}`;
}

// Format currency: $47,500,000
export function formatCurrency(amount) {
  if (amount === null || amount === undefined) return '—';
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}

// Format number with commas
export function formatNumber(num) {
  if (num === null || num === undefined) return '—';
  return new Intl.NumberFormat('en-AU').format(num);
}

// Calculate days until date
export function daysUntil(dateString) {
  if (!dateString) return null;
  const date = new Date(dateString);
  const now = new Date('2025-12-30'); // Demo "as at" date
  const diff = Math.ceil((date - now) / (1000 * 60 * 60 * 24));
  return diff;
}

// Get status color class
export function getStatusClass(status) {
  switch (status?.toLowerCase()) {
    case 'verified':
    case 'yes':
    case 'complete':
      return 'badge-verified';
    case 'needs review':
    case 'pending':
    case 'in progress':
      return 'badge-needs-review';
    case 'broken':
    case 'overdue':
    case 'no':
      return 'badge-broken';
    default:
      return 'badge-restricted';
  }
}

// Mask sensitive data
export function maskData(value, type = 'default') {
  if (!value) return '—';
  
  switch (type) {
    case 'dob':
      return '•• ••• ••••';
    case 'licence':
      return '••••••••••';
    case 'address':
      return '•••••••••••••••••••';
    case 'phone':
      return '+61 ••• ••• •••';
    case 'email':
      const [name, domain] = value.split('@');
      return `${name.charAt(0)}${'•'.repeat(name.length - 1)}@${domain}`;
    default:
      return '••••••••';
  }
}

// Calculate overall data completeness
export function calculateCompleteness(completeness) {
  if (!completeness) return 0;
  const values = Object.values(completeness).filter(v => typeof v === 'number' && !Number.isNaN(v));
  if (values.length === 0) return 0;
  return Math.round(values.reduce((a, b) => a + b, 0) / values.length);
}
